import { WrapperUIRoot } from "./WrapperUI.styles";

import React, { useEffect, useRef, useState, useCallback } from "react";
import actionsList from "../../app/actions-list";

import { CustomUI } from "../CustomUI";
import { useRouteParams } from "../../context/RouteParamsContext";

import {
  ArcwarePixelStreaming,
  ArcwareApplication,
  ArcwareInit,
} from "@arcware-cloud/pixelstreaming-websdk";
import { Box, useTheme } from "@mui/material";
import { DialogGeneric } from "../DialogGeneric";
import { NavigationInstructions } from "../NavigationInstructions";
import { Loader } from "../Loader";

const CONTAINER_ID = "shared-stream-container";

export const WrapperUI = () => {
  const theme = useTheme();
  const [showingOverlay, setShowingOverlay] = useState(false);
  const interactiveVideoRef = useRef(null);
  const { projectName } = useRouteParams();

  const ref = useRef(null);
  const [videoInitialized, setVideoInitialized] = useState(false);
  const [applicationResponse, setApplicationResponse] = useState();
  const [arcwareApplication, setArcwareApplication] = useState();
  const [screenshotCounter, setScreenshotCounter] = useState(0);
  const [showNavigationInstructionDialog, setShowNavigationInstructionDialog] =
    useState(true);

  const handleDialogShow = (value, reason) => {
    if (reason === "backdropClick") return;
    setShowNavigationInstructionDialog(value);
  };

  const play = useCallback(() => {
    interactiveVideoRef?.current?.playVideo();
    setShowingOverlay(true);
  }, []);

  const createFile = (file) => {
    // console.log("createFile", file);
    const blob = new Blob(file.data, { type: file.mimetype });
    // console.log("blob", blob);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const counterString = String(screenshotCounter).padStart(2, "0");
    a.href = url;
    a.download = `screenshot${counterString}${file.extension}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    setScreenshotCounter(screenshotCounter + 1);
  };

  useEffect(() => {
    if (ref.current) return;

    const { Config, PixelStreaming, Application } = ArcwareInit(
      {
        shareId: "share-6bc707ea-9801-41ff-b573-0fbf1dfe0a95",
      },
      {
        initialSettings: {
          AutoConnect: true,
          TouchInput: true,
        },
        settings: {
          audioButton: true,
          fullscreenButton: true,
          micButton: false,
          settingsButton: false,
          infoButton: false,
          connectionStrengthIcon: false,
        },
      }
    );

    if (window.location.hostname === "localhost") {
      window.arc = {
        app: Application,
        aps: PixelStreaming,
      };
    }

    setArcwareApplication(Application);
    Application.getApplicationResponse((response) => {
      setApplicationResponse(response);
      // console.log(
      //   "Application.webRtcController.file",
      //   Application.webRtcController.file
      // );
      window.file = Application.webRtcController.file;
      if (response.startsWith("CreateScreenshot")) createFile(window.file);
    });

    PixelStreaming.videoInitializedHandler.add(() => setVideoInitialized(true));

    window.application = Application; // Dev-only
    ref.current = document.querySelector(`#${CONTAINER_ID}`);
    if (!ref.current) throw new Error("Ref.current is undefined.");
    ref.current.appendChild(Application.rootElement);
  }, []);

  useEffect(() => {
    return () => {
      if (videoInitialized && arcwareApplication) {
        arcwareApplication.stream.removePlayer();
        let model = "";
        if (projectName === "airbus") model = "av";
        if (projectName === "electra") model = "ev";
        if (projectName) arcwareApplication.emitUIInteraction({ cv: model });
      }
    };
  }, [arcwareApplication, projectName, videoInitialized]);

  useEffect(() => {
    if (videoInitialized);
  }, [videoInitialized]);

  const [opacityLoader, setOpacityLoader] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    setShowLoader(false);
    setOpacityLoader(false);
    if (applicationResponse === '{ "loading_screen": "disabled" }') {
      setTimeout(() => {
        setOpacityLoader(false);
        setTimeout(() => setShowLoader(false), 1000);
      }, 2000);
    }
  }, [applicationResponse]);

  return (
    <WrapperUIRoot
      id={CONTAINER_ID}
      sx={{
        width: "100%",
        height: "100%",
        position: "relative",
      }}
    >
      {showLoader && <Loader show={opacityLoader} type="configuration" />}
      <DialogGeneric
        close={!opacityLoader}
        show={showNavigationInstructionDialog}
        onHandleClose={handleDialogShow}
        maxWidth="lg"
      >
        <NavigationInstructions
          show={opacityLoader}
          onHandleClose={handleDialogShow}
          videoInitialized={videoInitialized}
          arcwareApplication={arcwareApplication}
        />
      </DialogGeneric>
      {videoInitialized && (
        <>
          <CustomUI
            emitUIInteraction={arcwareApplication?.emitUIInteraction}
            applicationResponse={applicationResponse}
            actionsList={actionsList}
            loading={false}
            showingOverlay={showingOverlay}
          />
        </>
      )}
    </WrapperUIRoot>
  );
};
